import { Box } from "@mui/system";
import { MdSignalWifiStatusbarConnectedNoInternet } from "react-icons/md";
import { Typography } from "@mui/material";

export default function NoInternet() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
        background: "black",
      }}
    >
      <Box
        sx={{
          background: "#202741",
          height: "300px",
          width: "600px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          color: "#FFFFFF",
          gap: "10px",
          borderRadius: "15px",
        }}
      >
        <MdSignalWifiStatusbarConnectedNoInternet
          size={50}
          style={{ fontSize: "8vw" }}
        />
        <Typography
          sx={{ fontSize: "1.5vw", fontWeight: "bold", textAlign: "center" }}
        >
          No internet connection
        </Typography>
        <Typography sx={{ fontSize: "1vw", textAlign: "center" }}>
          Make sure wifi or cellular connection is turned on <br /> and then try
          again
        </Typography>
      </Box>
    </Box>
  );
}
